module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1505-7f0b25e2c0ae5bd933e2bf6110688899.png";